import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    const check = async () => {
      try {
        setUser((await api.get("/auth/me")).data);
      } catch {
        try {
          await api.post("/auth/refresh");
          setUser((await api.get("/auth/me")).data);
        } catch {
          setUser(false);
        }
      }
    };
    check();
  }, []);
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setUser(false); };
  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const RequireAdmin = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center text-slate-500">Checking session…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
